// 引入Message封装消息提示
import { Message } from "element-ui"
// 引入MessageBox封装确认提示
import { MessageBox } from 'element-ui'
// 引入axios
import axios from 'axios';

let util = {
    hint: function (code, msg) {
        switch (code) {
            case 0:
                Message({
                    duration: 2000,
                    showClose: true,
                    message: '' + msg,
                    type: 'success'
                });
                break;
            case 2:
                Message({
                    duration: 2000,
                    showClose: true,
                    message: '' + msg,
                    type: 'warning'
                });
                break;
            case 400:
                Message({
                    duration: 2000,
                    showClose: true,
                    message: '' + msg,
                    type: 'error'
                });
                break;
            default:
                Message({
                    duration: 2000,
                    showClose: true,
                    message: '' + msg,
                    type: 'error'
                });
                break;
        };
    },
    affirm: function (code, title, msg) {
        switch (code) {
            case 0:
                // 普通提示框
                MessageBox.$alert('' + msg, '' + title, {
                    confirmButtonText: '确定',
                    callback: action => {
                        return true;
                    }
                });
                break;
            case 2:
                // 消息确认框
                MessageBox.$confirm('' + msg, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    return true;
                }).catch(() => {
                    return false;
                });
                break;
            case 400:
                // 内容居中的提示框
                MessageBox.$confirm('' + msg, '' + title, {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: true
                }).then(() => {
                    return true;
                }).catch(() => {
                    return false
                });
                break;
            default:

                break;
        };
    },

    getDays: function () {
        var date = new Date();//时间戳为10位需*1000，时间戳为13位的话不需乘1000
        var Y = date.getFullYear() + '-';
        var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
        var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
        var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
        var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes());
        let strDate = Y + M + D + h + m;
        return strDate;
    },

    judge: function(strDateStart, strDateEnd) {
		strDateStart = strDateStart.split(" ");
		strDateEnd = strDateEnd.split(" ");
		var strSeparator = "-"; //日期分隔符
		var oDate1;
		var oDate2;
		var iDays;
		oDate1 = strDateStart[0].split(strSeparator);
		oDate2 = strDateEnd[0].split(strSeparator);
		var strDateS = new Date(oDate1[0], oDate1[1] - 1, oDate1[2]);
		var strDateE = new Date(oDate2[0], oDate2[1] - 1, oDate2[2]);
		iDays = parseInt(Math.abs(strDateS - strDateE) / 1000 / 60 / 60 / 24) //把相差的毫秒数转换为天数
		return iDays;
	},

    // 计算得到当前页面是否还存在其他已使用的券，避免与全免券冲突
    count: function(e, classify) {
        let array = e;
        if (classify == "add") {
          let num = 0;
          for (let i = 0; i < array.length; i++) {
            // 循环列表得到每个数据
            if (array[i].remark > 0) {
              num = array[i].remark - 1;
            }
          }
          return num;
        } else if (classify == "can") {
          let num = 0;
          for (let i = 0; i < array.length; i++) {
            // 循环列表得到每个数据
            if (array[i].remark > 0) {
              num++;
            }
          }
          return num;
        }
      },

      // 判断当前叠加属性
    addcount: function(data) {
        var num = 0;
        for (var i = 0; i < data.length; i++) {
          num = num + parseInt(data[i].remark);
        }
        return num;
      },

    add0: function (m) { return m < 10 ? '0' + m : m },

    timeFormat: function (timestamp) {
        //timestamp是整数，否则要parseInt转换,不会出现少个0的情况
        var time = new Date(timestamp);
        var year = time.getFullYear();
        var month = time.getMonth() + 1;
        var date = time.getDate();
        var hours = time.getHours();
        var minutes = time.getMinutes();
        var seconds = time.getSeconds();
        return year + '-' + this.add0(month) + '-' + this.add0(date) + ' ' + this.add0(hours) + ':' + this.add0(minutes) + ':' + this.add0(seconds);
    },

     // 将日期时间转换为纯字符串
  timeCharge:function(data) {
    var name = data.replace(/\-/g, '');
    var names = name.replace(/\ /g, '');
    var newName = names.replace(/\:/g, '');

    return newName
  },

    derive: function (data, count) {
        var info = data;
        var limit = "";
        if (count > 10000) {
            limit = 1000;
        } else if (count > 1000) {
            limit = 500;
        } else if (count > 500) {
            limit = 200;
        } else if (count > 200) {
            limit = 50;
        } else if (count < 100 && count > 50) {
            limit = 20;
        } else if (count < 50) {
            limit = 10;
        }
        var num = Math.ceil(count / limit);
        let tab = async (num) => {
            var list = [];
            for (var i = 1; i <= num; i++) {
                let data = {
                    // 商家ID
                    shopId: info.shopId,
                    // 开始时间
                    timeStart: info.timeStart,
                    // 结束时间
                    timeEnd: info.timeEnd,
                    // 请求数据参数
                    page: i,
                    limit: limit,
                    plate: info.plate,
                };
                try {
                    let { code, data: resData, msg } = await axios.post('getOrderList', data);
                    if (code == 0) {
                        list.length == 0 ? list = resData : list.push.apply(list, resData);
                    } else {
                        util.hint(code, msg);
                    }
                } catch (reject) {
                    console.log(reject)
                }
            }
            return list
        }
        return tab(num);
    },

    dwanLoad: function (tabData, list) {
        let parkName = JSON.parse(sessionStorage.getItem("shopData")).parkName;
        let shopName = JSON.parse(sessionStorage.getItem("shopData")).shop.name;
        var data = tabData;
        for (let i = 0; i < data.length; i++) {
            for (let j = 0; j < list.length; j++) {
                for (var item in data[i]) {
                    if (item == list[j]) {
                        if (item == 'parkId') {
                            data[i][item] = parkName;
                        } else if (item == 'shopId') {
                            data[i][item] = shopName;
                        } else if (item == "type") { // 在优惠明细中判断券类型
                            if (data[i][item] == 1) {
                                data[i][item] = '时间券';
                            } else if (data[i][item] == 2) {
                                data[i][item] = '金额券';
                            } else if (data[i][item] == 3) {
                                data[i][item] = '折扣券';
                            } else if (data[i][item] == 4) {
                                data[i][item] = '全免券';
                            }
                        } else if (item == "value") { // 在优惠明细中判断券类型
                            if (data[i].unit == 1) {
                                data[i][item] = data[i][item] + '小时';
                            } else if (data[i].unit == 2) {
                                data[i][item] = data[i][item] + '分钟';
                            } else if (data[i].unit == 3) {
                                data[i][item] = data[i][item] + '天';
                            } else if (data[i].unit == 4) {
                                data[i][item] = data[i][item] + '元';
                            } else if (data[i].unit == 5) {
                                data[i][item] = data[i][item] + '折';
                            } else if (data[i].unit == 4) {
                                data[i][item] = '全免券';
                            }
                        }
                    }
                }
            }
        };
        return data
    }
}

export {
    util
}


// WEBPACK FOOTER //
// ./src/utils/global.js